import { Box, Button, Typography } from '@mui/material';
import PlayArrowRounded from '@mui/icons-material/PlayArrowRounded';
import PauseRounded from '@mui/icons-material/PauseRounded';

import { SHRED_COLORS, SHRED_COPY, SHRED_FONTS } from '../constants';
import { Panel, focusRing } from './shared';

const Replay = ({ maxDay, dayCount, displayDay, playing, isReplaying, loading, onPlay, onPause, onSeek, onReset, ended, errorText }) => {
  if (maxDay < 1) return null;
  return (
    <Panel
      role="group"
      aria-label={SHRED_COPY.REPLAY_TITLE}
      sx={{ p: 2, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap', background: SHRED_COLORS.panelRaised }}
    >
      <Button
        onClick={playing ? onPause : onPlay}
        startIcon={playing ? <PauseRounded /> : <PlayArrowRounded />}
        sx={{
          ...focusRing,
          background: SHRED_COLORS.heat,
          color: SHRED_COLORS.ink,
          fontFamily: SHRED_FONTS.body,
          fontWeight: 700,
          borderRadius: '999px',
          px: 2.5,
          textTransform: 'none',
          '&:hover': { filter: 'brightness(1.1)', background: SHRED_COLORS.heat },
        }}
      >
        {playing ? SHRED_COPY.REPLAY_PAUSE : SHRED_COPY.REPLAY_PLAY}
      </Button>
      <Box sx={{ minWidth: 120 }}>
        <Typography sx={{ fontFamily: SHRED_FONTS.display, fontWeight: 800, fontSize: 28, lineHeight: 1, textTransform: 'uppercase' }}>
          Day {displayDay}
          <Box component="span" sx={{ fontSize: 14, color: SHRED_COLORS.muted, ml: 0.75, fontFamily: SHRED_FONTS.numeric }}>
            / {dayCount}
          </Box>
        </Typography>
        <Typography sx={{ fontFamily: SHRED_FONTS.body, fontSize: 12, color: SHRED_COLORS.muted }}>
          {isReplaying ? 'Replaying the contest' : ended ? SHRED_COPY.REPLAY_TITLE : 'Scrub back through the days'}
          {loading ? '…' : ''}
        </Typography>
      </Box>
      <Box
        component="input"
        type="range"
        min={1}
        max={maxDay}
        step={1}
        value={displayDay}
        onChange={(event) => onSeek(Number(event.target.value))}
        aria-label="Contest day"
        aria-valuetext={`Day ${displayDay} of ${dayCount}`}
        sx={{
          ...focusRing,
          flex: '1 1 200px',
          minWidth: 0,
          accentColor: SHRED_COLORS.flame,
          height: 28,
        }}
      />
      {errorText && (
        <Typography role="alert" sx={{ flexBasis: '100%', fontFamily: SHRED_FONTS.body, fontSize: 13, color: SHRED_COLORS.gold }}>
          {errorText}
        </Typography>
      )}
      <Button
        onClick={onReset}
        disabled={!isReplaying}
        aria-hidden={!isReplaying}
        tabIndex={isReplaying ? 0 : -1}
        sx={{
          ...focusRing,
          visibility: isReplaying ? 'visible' : 'hidden',
          color: SHRED_COLORS.gold,
          fontFamily: SHRED_FONTS.body,
          fontWeight: 600,
          textTransform: 'none',
        }}
      >
        {ended ? 'Final results' : SHRED_COPY.REPLAY_LIVE}
      </Button>
    </Panel>
  );
};

export default Replay;
